<template>
  <div class="inventory">
    <b-breadcrumb :items="items"></b-breadcrumb>

    <div class="headerPage">
      <div class="container-fluid">
        <div class="row">
          <div class="col-4 contentHeader">
            <div class="d-flex justify-content-start">
              <span>Número:</span>
              <input
                type="text"
                class="form-control"
                disabled
                ref="number_code_ref"
                v-model="number_code"
                style="margin-left: 10px; align-items: center; display: flex"
              />
            </div>
          </div>
          <div class="col-8" v-if="create">
            <a id="hiddenDownloadLink" style="display: none;"></a>
            <div
              class="w-100 h-100 d-flex justify-content-end align-items-center"
              style="padding-right: 3vw"
            >
              <PdfExportProgress
                v-if="loadingPdfJob"
                :state="currentState"
                :progress="progress"
                :status="pdfStatus"
                :expected-completion-at="expectedCompletionAt"
              />
              <b-dropdown text="Exportar" class="m-md-2" v-if="!loadingPdfJob">
                <b-dropdown-item @click="handleExportPdf">
                  {{ isPdfOld ? 'Gerar PDF' : 'Download PDF' }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
          <div class="col-8" v-if="!create">
            <div
              class="w-100 h-100 d-flex justify-content-end align-items-center"
              style="padding-right: 3vw"
            >
              <button
                class="btn btn-secondary float-right"
                v-on:click="createInventory()"
              >
                Criar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="create">
      <div class="container-fluid">
        <div class="form-group col-md-4 mt-2">
          <label>
            Responsável Técnico
            <span>*</span>
          </label>
          <multiselect
            v-model="selectedResponsibles"
            :options="technicalResponsibles"
            track-by="id"
            label="technical_responsible_name"
            placeholder="Selecione os Responsáveis Técnicos"
            :multiple="true"
            :clear-on-select="false"
            :close-on-select="false"
            :allow-empty="true"
            :hide-selected="true"
            :disabled="!canAccess()"
          >
          </multiselect>
      </div>
        <div class="row">
          <div class="col-12">
            <div class="navBarSection">
              <div
                class="navBarItem"
                v-bind:class="{ active: isSelectedSection('machines') }"
                v-on:click="selectSection('machines')"
              >
                <font-awesome-icon icon="suitcase" />
                <span>MÁQUINAS</span>
              </div>
              <div
                class="navBarItem"
                v-bind:class="{ active: isSelectedSection('anexos') }"
                v-on:click="selectSection('anexos')"
              >
                <font-awesome-icon icon="paperclip" />
                <span>ANEXOS</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <b-modal
        ref="photo-modal"
        size="xl"
        title="Adicionar Imagem"
        @ok="saveImage(machineSelectedId)"
      >
        <ImageEditor ref="imageEditor" :machine_id="machineSelectedId" :selected-directory="'Fotos'" :company_id="localCompanyId"></ImageEditor>
        <template v-slot:modal-cancel>Cancelar</template>
        <template v-slot:modal-ok>Salvar</template>
      </b-modal>
      <div class="container-fluid">
        <div class="row attachments" v-if="isSelectedSection('anexos')">
          <div class="col-8" v-if="localCompanyId && id">
            <AttachmentsList
              :company_id="localCompanyId"
              typeDocument="inventory"
              :document_id="id"
              :readonly="!edit_permission"
            ></AttachmentsList>
          </div>
        </div>

        <div class="row m-4" v-if="isSelectedSection('machines')">
          <div class="col-4">
            <div class="form-group">
              <span class="label">Nº Revisão</span>
              <input
                v-model="revision_number"
                class="form-control"
                :disabled="!edit_permission"
              />
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <span class="label">Nº ART Vinculada</span>
              <input
                v-model="linked_art"
                class="form-control"
                :disabled="!edit_permission"
              />
            </div>
          </div>
          <div class="col-4 mt-4">
            <template v-if="edit_permission">
              <div>
                <button
                  class="btn btn-primary float-left"
                  v-on:click="newMachineForm()"
                >
                  <span v-show="!creatingNewMachine">
                    Nova Máquina
                    <font-awesome-icon icon="plus" />
                  </span>
                  <span v-show="creatingNewMachine">
                    Esconder
                    <font-awesome-icon icon="minus" />
                  </span>
                </button>
              </div>
            </template>
          </div>

          <div v-show="creatingNewMachine" style="padding:20px 15px; margin-left:16px;" class="machineDetails col-12">
            <template>
              <div class="card-content">
                <div class="row">
                  <div class="col-6">
                    <div class="form-group">
                      <label class="textGray">
                        Nome
                        <span>*</span>
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="newMachine.name"
                      />
                    </div>
                    <div class="form-group">
                      <label class="textGray">
                        Setor
                        <span>*</span>
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="newMachine.sector"
                      />
                    </div>
                    <div class="form-group">
                      <label class="textGray">
                        Tipo
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="newMachine.type"
                      />
                    </div>
                    <div class="form-group">
                      <label class="textGray"
                        >Capacidade da Máquina/Equipamento</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        v-model="newMachine.capacity"
                      />
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <label class="textGray">
                        Marca
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="newMachine.manufacturer"
                      />
                    </div>
                    <div class="form-group">
                      <label class="textGray">Ano de Fabricação</label>
                      <input
                        name="manufactured_at"
                        type="text"
                        v-mask="'####'"
                        v-model="newMachine.manufactured_at"
                        class="form-control"
                      />
                    </div>
                    <div class="form-group">
                      <label class="textGray">
                        Tensão Elétrica
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="newMachine.tension"
                      />
                    </div>
                    <div class="form-group">
                      <label class="textGray">
                        Função da Máquina
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="newMachine.machine_function"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="form-group">
                      <label class="textGray">Número de Série</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="newMachine.serie_number"
                      />
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="textGray" for="photo">
                    Foto:
                    <span>*</span>
                  </label>
                  <b-form-file
                    id="input-machine-foto"
                    v-model="newMachine.photo_id"
                    placeholder="Escolha um arquivo"
                    drop-placeholder="Arraste o arquivo aqui..."
                    browse-text="Procurar"
                    accept="image/jpeg, image/png, image/jpg"
                    v-on:change="uploadImage"
                  ></b-form-file>
                </div>
                <div class="form-group">
                  <label class="textGray" for="observations">
                    Observações
                  </label>
                  <textarea
                    v-model="newMachine.observations"
                    class="form-control"
                  ></textarea>
                </div>
                <div class="row">
                  <div class="col-12">
                    <button
                      class="btn btn-success float-center"
                      v-on:click="createNewMachine()"
                      v-if="canAccess()"
                    >
                      Salvar Máquina
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-padding">
                    <b-alert v-show="newMachineSuccess" variant="success" show
                      >Nova Máquina adicionada</b-alert
                    >
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-padding">
                    <b-alert v-show="warningMachine" variant="warning" show
                      >Preencha todos os campos</b-alert
                    >
                  </div>
                </div>
              </div>
            </template>
          </div>
          <!-- <div class="col-4">
            <div class="form-group">
              <span class="label">Cidade</span>
              <input
                v-model="place"
                class="form-control"
                :disabled="!edit_permission"
              />
            </div> -->
          
          <div class="col-12 machineDetails" style="margin-left:16px;">
            <div class="col-12 mt-3 mb-3 d-flex justify-content-between align-items-center">
              <h5>Selecione as máquinas desse Inventário:</h5>
              <button class="btn btn-secondary" @click="toggleSelectAll" :disabled="!canAccess()">
                {{ allSelected ? 'Desmarcar Todas' : 'Selecionar Todas' }}
              </button>
            </div>

            <div
              v-for="(machine, index) in machines"
              v-bind:key="machine.id"
              class="col-12"
            >
              <Accordion
                lazy-body
                :preload-images="machineImageUrls(machine)"
              >
                <template v-slot:title>
                  <div class="row">
                    <div class="col-2">
                      <!-- O cabeçalho do Accordion inteiro alterna a abertura, e o
                           checkbox fica dentro dele: sem interromper a propagação,
                           marcar uma máquina também abria o painel dela. -->
                      <input
                        type="checkbox"
                        name="selected"
                        class="form-check-input ml-1"
                        v-model="machine.selected"
                        style="height: 18px; width: 18px"
                        :disabled="!canAccess()"
                        @click.stop
                      />
                    </div>
                    <div class="col-10">
                      <span class="label">Máquina:</span>
                      <span class="label content">{{ machine.name }}</span>
                    </div>
                  </div>
                </template>
                <template v-slot:body>
                  <p>VISÃO GERAL DA MÁQUINA</p>
                  <div class="card-main-photo">
                    <span>{{ machine.photoUrl }}</span>
                    <img
                      style="width: 24%; height: auto; margin-top: 20px;"
                      :src="machine.photo.url"
                      loading="lazy"
                      decoding="async"
                      class="image-rounded"
                    />
                  </div>
                  <br />
                  <div class="card-content">
                    <div class="row">
                      <div class="col-6">
                        <div class="form-group">
                          <label class="textGray">Setor</label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="machine.sector"
                            name="sector"
                            v-bind:class="{
                              'input-error': showMachineError(index, 'sector'),
                            }"
                            :disabled="!canAccess()"
                          />
                          <div
                            class="general-error"
                            v-if="showMachineError(index, 'sector')"
                          >
                            O campo Setor é necessário.
                          </div>
                        </div>
                        <div class="form-group">
                          <label class="textGray">Tipo</label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="machine.type"
                            name="type"
                            v-bind:class="{
                              'input-error': showMachineError(index, 'type'),
                            }"
                            :disabled="!canAccess()"
                          />
                          <div
                            class="general-error"
                            v-if="showMachineError(index, 'type')"
                          >
                            O campo Tipo é necessário.
                          </div>
                        </div>
                        <div class="form-group">
                          <label class="textGray"
                            >Capacidade da Máquina/Equipamento</label
                          >
                          <input
                            type="text"
                            class="form-control"
                            v-model="machine.capacity"
                            name="capacity"
                            v-bind:class="{
                              'input-error': showMachineError(
                                index,
                                'capacity'
                              ),
                            }"
                            :disabled="!canAccess()"
                          />
                          <div
                            class="general-error"
                            v-if="showMachineError(index, 'capacity')"
                          >
                            O campo Capacidade é necessário.
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="form-group">
                          <label class="textGray">Marca</label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="machine.manufacturer"
                            name="manufacturer"
                            v-bind:class="{
                              'input-error': showMachineError(
                                index,
                                'manufacturer'
                              ),
                            }"
                            :disabled="!canAccess()"
                          />
                          <div
                            class="general-error"
                            v-if="showMachineError(index, 'manufacturer')"
                          >
                            O campo Fabricante é necessário.
                          </div>
                        </div>
                        <div class="form-group">
                          <label class="textGray"
                            >Ano de Fabricação (Caso não identificado, deixar em
                            branco)</label
                          >
                          <input
                            type="text"
                            class="form-control"
                            v-model="machine.manufactured_at"
                            name="manufactured_at"
                            v-mask="'####'"
                            v-bind:class="{
                              'input-error': showMachineError(
                                index,
                                'manufactured_at'
                              ),
                            }"
                            :disabled="!canAccess()"
                          />
                          <div
                            class="general-error"
                            v-if="showMachineError(index, 'manufactured_at')"
                          >
                            O campo Ano de Fabricação é necessário.
                          </div>
                        </div>
                        <div class="form-group">
                          <label class="textGray">Tensão Elétrica</label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="machine.tension"
                            name="tension"
                            v-bind:class="{
                              'input-error': showMachineError(index, 'tension'),
                            }"
                            :disabled="!canAccess()"
                          />
                          <div
                            class="general-error"
                            v-if="showMachineError(index, 'tension')"
                          >
                            O campo Tensão é necessário.
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6">
                        <div class="form-group">
                          <label class="textGray">Número de Série</label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="machine.serie_number"
                            name="serie_number"
                            v-bind:class="{
                              'input-error': showMachineError(
                                index,
                                'serie_number'
                              ),
                            }"
                            :disabled="!canAccess()"
                          />
                          <div
                            class="general-error"
                            v-if="showMachineError(index, 'serie_number')"
                          >
                            O campo Número de Série é necessário.
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="form-group">
                          <label class="textGray">Função da Máquina</label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="machine.machine_function"
                            name="machine_function"
                            v-bind:class="{
                              'input-error': showMachineError(
                                index,
                                'machine_function'
                              ),
                            }"
                            :disabled="!canAccess()"
                          />
                          <div
                            class="general-error"
                            v-if="showMachineError(index, 'machine_function')"
                          >
                            O campo Função da Máquina é necessário.
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group">
                          <label for="observations">Observações</label>
                          <textarea
                            v-model="machine.observations"
                            class="form-control"
                            name="observations"
                            v-bind:class="{
                              'input-error': showMachineError(
                                index,
                                'observations'
                              ),
                            }"
                            :disabled="!canAccess()"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12" style="padding: 2vh 2vw">
                        <button
                          class="btn btn-success float-right"
                          v-if="canAccess()"
                          v-on:click="updateMachine(index)"
                        >
                          Salvar Máquina
                          <font-awesome-icon icon="save" />
                        </button>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <b-alert v-show="machineSuccess" variant="success" show
                          >Máquina atualizada!</b-alert
                        >
                      </div>
                    </div>
                    <br />
                    <p>SISTEMAS DE SEGURANÇA EXISTENTES</p>
                    <div
                      class="row"
                      v-if="canAccess()"
                      style="
                        border: 1px solid #eaeaee;
                        padding: 20px;
                        border-radius: 8px;
                        margin: 5px;
                      "
                    >
                      <span class="col-12">Novo Sistema de Segurança</span>
                      <div
                        class="col-4 d-flex justify-content-center align-items-center"
                        style="padding-top: 15px"
                      >
                        <!-- <div class="new-photo"> -->
                        <!-- <div class="form-group"> -->
                        <!-- <label class="textGray">Foto</label> -->
                        <button
                          class="btn btn-secondary"
                          v-on:click="openModal('photo-modal', machine.id)"
                          v-if="!tempImage[machine.id]"
                        >
                          <font-awesome-icon
                            icon="camera"
                            class="mr-2"
                          />Adicionar Foto
                        </button>
                        <img
                          v-if="tempImage[machine.id]"
                          :src="tempImage[machine.id]"
                          alt
                          loading="lazy"
                          decoding="async"
                          style="width: 40%"
                          class="image-rounded"
                        />
                        <!-- <b-form-file
                          ref="tempPath_ref"
                          v-model="tempPath"
                          placeholder="Escolha uma imagem"
                          drop-placeholder="Arraste o arquivo aqui..."
                          browse-text="Procurar"
                          accept="image/jpeg, image/png, image/jpg"
                          v-on:change="uploadImage"
                        ></b-form-file>-->
                        <!-- </div> -->
                        <!-- </div>  -->
                        <span class="text-danger">{{ message }}</span>
                      </div>
                      <div class="col-6">
                        <div class="d-flex align-items-center h-100 w-100">
                          <div class="form-group w-100">
                            <label class="textGray">Descrição</label>
                            <input
                              ref="tempDescription_ref"
                              type="text"
                              class="form-control"
                              v-model="tempDescription"
                              style="resize: none"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-2">
                        <div
                          class="w-100 h-100 d-flex justify-content-end align-items-center"
                          style="padding-top: 19px"
                        >
                          <button
                            class="btn btn-secondary float-right"
                            v-on:click="addProtectionSystem(machine)"
                          >
                            <font-awesome-icon
                              icon="plus"
                              class="mr-2"
                            />Adicionar
                          </button>
                        </div>
                      </div>
                      <div class="col-12 col-padding">
                        <b-alert v-show="erroDevice" variant="warning" show
                          >É necessário uma imagem e uma descrição</b-alert
                        >
                        <b-alert v-show="limitExceeded" variant="warning" show
                            >O limite é de 8 registros apenas</b-alert
                          >
                      </div>
                    </div>
                    <div class="row" v-if="renderPs">
                      <div
                        class="col-4"
                        v-for="(
                          protection_system, index
                        ) in machine.protection_systems"
                        v-bind:key="protection_system.id"
                      >
                        <div class="card-photo">
                          <div
                            class="button-remove-photo"
                            v-if="canAccess()"
                          >
                            <font-awesome-icon
                              icon="times"
                              v-on:click="removePhoto(machine, index)"
                            />
                          </div>
                          <img
                            :src="protection_system.image"
                            loading="lazy"
                            decoding="async"
                            style="width: 70%; height: auto; margin-top: 20px"
                            class="image image-rounded"
                          />
                          <span>{{ protection_system.description }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <!-- <button class="btn btn-secondary float-right" v-on:click="save(machine)">Salvar</button> -->
                      </div>
                    </div>
                  </div>
                </template>
              </Accordion>
            </div>
          </div>
          </div>
          <br />
          <div class="col-12" v-if="edit_permission">
            <button id="btnSalvarInventario"
              class="btn btn-success float-right button-new"
              v-on:click="updateInventory()"
              :disabled="success"
            >
              <span> Salvar Inventário <font-awesome-icon icon="save" /> </span>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-padding">
            <b-alert dismissible fade v-show="success" variant="success" show
              >Inventário Salvo</b-alert
            >
            <b-alert
              dismissible
              @dismissed="dismissCountDown = 0"
              @dismiss-count-down="countDownChanged"
              fade
              :show="dismissCountDown"
              variant="warning"
              >Você possui {{ registersStack[registersStack.length - 1] }} sem
              salvar. Por favor, salve tudo para continuar</b-alert
            >
          </div>
          <div class="alertError" style="width: 100%; height: 50px"></div>
        </div>
      </div>
    </div>

</template>

<script>
import axios from "@/api/axios";
import Accordion from "@/components/Accordion.vue";
import AttachmentsList from "@/components/AttachmentsList.vue";
import ImageEditor from "@/components/ImageEditor.vue";
import PdfExportProgress from "@/components/PdfExportProgress.vue";
import { canAccess } from "@/utils/canAccess";
import moment from "moment";
import Multiselect from "vue-multiselect";
import { required } from "vuelidate/lib/validators";

export default {
  name: "Inventory",
  components: {
    Accordion,
    AttachmentsList,
    ImageEditor,
    PdfExportProgress,
    Multiselect
  },
  props: {
    id: String,
    company_id: String,
  },
  watch: {
    company_id(newVal) {
      this.localCompanyId = newVal;
      if (newVal) {
        this.getCompany(newVal);
      }
    },
  },
  validations: {
    revision_number: {
      required,
    },
    linked_art: {
      required,
    },
    validations: {
      machine: {
        name: {
          required,
        },
        audio: {
          required,
        },
        type: {
          required,
        },
        capacity: {
          required,
        },
        tension: {
          required,
        },
        machine_function: {
          required,
        },
        manufacturer: {
          required,
        },
        manufactured_at: {
          required,
        },
        serie_number: {
          required,
        },
        photo_id: {
          required,
        },
        sector: {
          required,
        },
        observations: {
          required,
        },
      },
    },
  },
  data() {
    return {
      localCompanyId: this.company_id || localStorage.getItem('company_id'),
      renderPs: true,
      create: false,
      machines: [],
      tempImage: {},
      tempDescription: "",
      message: "",
      tempPath: "",
      number_code: "",
      place: "",
      creatingNewMachine: false,
      newMachine: {},
      newMachineSuccess: false,
      saving: false,
      revision_number: "",
      linked_art: "",
      selectedSection: "machines",
      success: false,
      machineSuccess: false,
      warningMachine: false,
      registersStack: [],
      technicalResponsibles: [],
      selectedResponsibles: [],
      items: [
        {
          text: "Documentos",
          href: "#/admin/Documents/Index",
        },
        {
          text: "",
          href: `#/admin/Documents/Company/${this.company_id || localStorage.getItem('company_id')}`,
        },
        {
          text: "Inventários",
          href: `#/admin/Documents/ListDocuments/${this.company_id || localStorage.getItem('company_id')}/Inventory`,
        },
        {
          text: "Inventário",
          active: true,
        },
      ],
      role: localStorage.getItem("auth.role"),
      edit_permission: this.role != "client" || !this.localCompanyId,
      erroDevice: false,
      limitExceeded: false,
      // registerError: false,
      dismissSecs: 5,
      dismissCountDown: 0,
      machineSelectedId: null,
      allSelected: false,
      progress: 0,
      expectedCompletionAt: null,
      currentState: "Aguardando para começar...",
      pdfWatcher: null,
      pdfWatcherDeadline: 0,
      pdfWatcherErrors: 0,
      // Só abre o PDF sozinho se a geração foi pedida nesta aba. Sem isso, abrir
      // a tela enquanto alguém gera em outro lugar dispararia uma aba inesperada.
      requestedExportHere: false,
      downloadUrl: "",
      pdfStatus: null,
      loadingPdfJob: false,
      isPdfOld: false,
      inventoryLastUpdatedAt: null,
    };
  },
  mounted: async function () {
    const loader = this.$loading.show();
    this.edit_permission = this.role != "client" || !this.localCompanyId;

    if (this.localCompanyId) {
      this.getCompany(this.localCompanyId);
    }

    if (this.localCompanyId) {
      this.generateNumberCode();
    } else {
      this.generateNumberCode();
    }
    if(this.id){
      this.create = true;
      await this.getInventory();
    }
    await this.getTechnicalResponsibles();
    await this.getMachinesByCompanyId();
    this.allSelected = this.machines.length > 0 && this.machines.every(m => m.selected);
    this.verifyPdfGeneration();
    loader.hide();
  },
  methods: {
    canAccess,
    machineImageUrls(machine) {
      const urls = [];

      if (machine.photo && machine.photo.url) {
        urls.push(machine.photo.url);
      }

      (machine.protection_systems || []).forEach(protectionSystem => {
        if (protectionSystem.image) {
          urls.push(protectionSystem.image);
        } else if (protectionSystem.photo && protectionSystem.photo.url) {
          urls.push(protectionSystem.photo.url);
        }
      });

      return Array.from(new Set(urls));
    },
    getCompany: function (company_id) {
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/admin/companies/${company_id}`)
        .then((response) => {
          this.items[1].text = response.data.data.corporate_name;
        });
    },
    formatDateTime(dateString) {
      if (!dateString) return '-';
      const date = new Date(dateString.replace(' ', 'T')); // transforma em formato ISO
      return date.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    /**
     * O atributo download só força o salvamento em mesma origem, e a API fica em
     * outro host/porta - o navegador ignorava o atributo e navegava na própria
     * aba, tirando o usuário da tela. Abrir em aba nova é o que DVS e APR fazem.
     */
    triggerDownload(url) {
      window.open(url, "_blank");
    },
    async verifyPdfGeneration(){
      this.loadingPdfJob = true;
      try{
        const { data } = await axios.get(
          `${process.env.VUE_APP_API_HOST}/export-inventory/${this.id}/status`
        );
        if(data.status === 'completed'){
          this.pdfStatus = data.status;
          this.downloadUrl = data.download_url;
          // Quem decide é o backend: ele compara a data do documento gerado com a
          // do inventário E das máquinas dele (editar máquina não altera o
          // updated_at do inventário, então comparar aqui deixava passar).
          this.isPdfOld = data.is_outdated === true;
          this.loadingPdfJob = false;
        }
        if(data.status === 'processing' || data.status === 'pending'){
          return this.startPdfWatcher();
        }
         if(data.status === 'failed'){
          this.loadingPdfJob = false;
          this.isPdfOld = true;
        }
      }catch(err){
        console.error("Erro ao verificar status do PDF:", err);
        this.loadingPdfJob = false;
        this.isPdfOld = true;
      }
    },
    async renewPdfJob(){
      try {
        const { data } = await axios.get(`${process.env.VUE_APP_API_HOST}/export-inventory/${this.id}/renew`)

        this.progress = data.progress_percentage || 0;
        this.currentState = data.status === 'pending'
          ? "Aguardando para começar..."
          : (data.current_state || "Preparando geração...");
        this.requestedExportHere = true;
        this.startPdfWatcher();
      } catch (err) {
        this.stopPdfWatcher({ recheck: false });
        this.loadingPdfJob = false;
        this.isPdfOld = true;
        console.error("Erro ao iniciar exportação:", err);
        this.$bvToast?.toast(err.response?.data?.message || 'Não foi possível iniciar a geração do PDF.', {
          title: 'Erro', variant: 'danger', solid: true, toaster: 'b-toaster-top-right',
        });
      }
    },
    handleExportPdf() {
      if(this.isPdfOld){
        this.renewPdfJob();
      }
      else{
        this.triggerDownload(`${this.downloadUrl}?t=${new Date().getTime()}`);
        this.stopPdfWatcher();
      }
    },
    startPdfWatcher() {
      if (this.pdfWatcher) return;
      this.loadingPdfJob = true;
      this.pdfWatcherErrors = 0;
      this.pdfWatcherDeadline = 0;
      this.schedulePdfStatusCheck(0);
    },
    schedulePdfStatusCheck(delay) {
      this.pdfWatcher = setTimeout(async () => {
        this.pdfWatcher = null;
        try {
          const { data } = await axios.get(
            `${process.env.VUE_APP_API_HOST}/export-inventory/${this.id}/status`
          );

          this.progress = data.progress_percentage;
          this.pdfStatus = data.status;
          this.currentState = data.status === 'pending'
            ? "Aguardando para começar..."
            : data.current_state;
          this.expectedCompletionAt = data.status === 'processing'
            ? this.formatDateTime(data.expected_completion_at)
            : null;
          this.pdfWatcherErrors = 0;

          // O relógio só começa quando um worker realmente assume o documento.
          // Aguardar um worker é um estado válido e não pode ser tratado como falha.
          if (data.status === 'processing' && data.expected_completion_at) {
            const expected = new Date(data.expected_completion_at).getTime();
            if (!isNaN(expected)) {
              this.pdfWatcherDeadline = expected + 15 * 60 * 1000;
            }
          }

          if (data.status === "completed") {
            this.downloadUrl = data.download_url;
            this.isPdfOld = data.is_outdated === true;
            this.loadingPdfJob = false;
            this.stopPdfWatcher({ recheck: false });

            if (this.requestedExportHere) {
              this.requestedExportHere = false;
              this.triggerDownload(`${this.downloadUrl}?t=${new Date().getTime()}`);
              this.$bvToast?.toast('PDF do inventário pronto. Abrimos em uma nova aba - se o navegador bloqueou, use Exportar > Download PDF.', {
                title: 'Exportação', variant: 'success', solid: true, toaster: 'b-toaster-top-right',
              });
            }
            return;
          }
          if(data.status === 'failed'){
            this.loadingPdfJob = false;
            this.isPdfOld = true;
            this.stopPdfWatcher({ recheck: false });
            this.$bvToast?.toast(data.error_message || data.message || 'Não foi possível gerar o PDF do inventário.', {
              title: 'Erro', variant: 'danger', solid: true, toaster: 'b-toaster-top-right',
            });
            return;
          }

          if (data.status === 'processing'
              && this.pdfWatcherDeadline
              && Date.now() > this.pdfWatcherDeadline) {
            this.loadingPdfJob = false;
            this.isPdfOld = true;
            this.stopPdfWatcher({ recheck: false });
            this.$bvToast?.toast('A geração do PDF está demorando mais que o esperado. Ela continua em andamento no servidor — reabra esta tela em alguns minutos.', {
              title: 'Atenção', variant: 'warning', solid: true, toaster: 'b-toaster-top-right',
            });
            return;
          }
        } catch (err) {
          console.error("Erro ao verificar status do PDF:", err);

          // Uma falha isolada de rede não deve encerrar o acompanhamento, mas
          // insistir indefinidamente contra um endpoint fora do ar deixaria o
          // usuário olhando um spinner que nunca termina.
          this.pdfWatcherErrors += 1;
          if (this.pdfWatcherErrors >= 5) {
            this.loadingPdfJob = false;
            this.isPdfOld = true;
            this.stopPdfWatcher({ recheck: false });
            this.$bvToast?.toast('Não foi possível consultar o status do PDF. Tente novamente.', {
              title: 'Erro', variant: 'danger', solid: true, toaster: 'b-toaster-top-right',
            });
            return;
          }
        }

        if (this.loadingPdfJob) {
          // Fila muda devagar; processamento mostra progresso detalhado.
          this.schedulePdfStatusCheck(this.pdfStatus === 'pending' ? 10000 : 3000);
        }
      }, delay);
    },
    /**
     * recheck: false encerra o acompanhamento de vez. Sem isso, desistir por
     * prazo ou erro cairia em verifyPdfGeneration(), que reinicia o watcher
     * enquanto o status for pending/processing - e a tela voltaria a girar
     * indefinidamente, que é justamente o que estamos corrigindo.
     */
    stopPdfWatcher({ recheck = true } = {}) {
      if (this.pdfWatcher) {
        clearTimeout(this.pdfWatcher);
        this.pdfWatcher = null;
      }

      if (recheck) {
        this.verifyPdfGeneration();
      }
    },
    toggleSelectAll() {
      this.allSelected = !this.allSelected;
      this.machines = this.machines.map(machine => ({
        ...machine,
        selected: this.allSelected
      }));
    },
    selectSection: function (section) {
      this.selectedSection = section;
    },
    isSelectedSection: function (section) {
      return this.selectedSection == section;
    },
    formatDate: function (date) {
      return moment(date).format("YYYY");
    },
    createInventory() {
      if (this.number_code && this.number_code != "") {
        let promise = axios.post(
          `${process.env.VUE_APP_API_HOST}/api/admin/inventories/`,
          {
            number_code: this.number_code,
            company_id: this.localCompanyId,
            executed_at: moment().format("YYYY-MM-DD"),
            technical_responsivel: this.selectedResponsibles
          }
        );
        promise.then((response) => {
          this.id = response.data.id;
          axios
            .post(
              `${process.env.VUE_APP_API_HOST}/api/admin/store-inventory-user`,
              {
                user_id: localStorage.getItem("auth.user_id"),
                inventory_id: this.id,
              }
            )
            .then(() => {
              this.create = true;
            })
            .catch(() => {
              this.warning = true;
            });
        });
      } else {
        this.$refs.number_code_ref.focus();
      }
    },
    validatorMachine() {
      if (
        this.newMachine.name &&
        this.newMachine.name != "" &&
        this.newMachine.sector &&
        this.newMachine.sector != "" &&
        this.tempImage &&
        this.tempImage != ""
      ) {
        return true;
      }
      return false;
    },
    createNewMachine: function () {
      this.submited = true;
      if (this.validatorMachine()) {
        const loader = this.$loading.show();
        axios
          .post(`${process.env.VUE_APP_API_HOST}/api/admin/machines`, {
            name: this.newMachine.name,
            type: this.newMachine.type,
            capacity: this.newMachine.capacity,
            manufacturer: this.newMachine.manufacturer,
            tension: this.newMachine.tension,
            machine_function: this.newMachine.machine_function,
            manufactured_at: this.newMachine.manufactured_at,
            serie_number: this.newMachine.serie_number,
            image: this.tempImage[this.newMachine.id],
            sector: this.newMachine.sector,
            company_id: this.localCompanyId,
            observations: this.newMachine.observations,
            inventory_id: this.id,
          })
          .then((response) => {
            this.registersStack.pop();
            this.newMachineSuccess = true;
            setTimeout(() => {
              this.neMachineSuccess = false;
              //redirect
            }, 1500);
            let newMachine = response.data;
            // newMachine.manufactured_at = this.formatDate(
            //   newMachine.manufactured_at
            // );
            if (!newMachine.protection_systems) {
              newMachine.protection_systems = [];
            }
            newMachine.selected = true;
            this.tempImage[this.newMachine.id] = null;
            this.machines.unshift(newMachine);
            this.$nextTick(() => {
              this.newMachine = {};
              this.creatingNewMachine = false;
            });
          })
          .catch(() => {
            this.warning = true;
          }).finally(() => loader.hide());
      } else {
        this.warningMachine = true;
        setTimeout(() => {
          this.warningMachine = false;
          //redirect
        }, 1500);
      }
    },
    getInventory: async function() {
      let promise = axios.get(
        `${process.env.VUE_APP_API_HOST}/api/admin/inventories/${this.id}`
      );
      promise.then((response) => {
        this.number_code = response.data.data.number_code;
        this.revision_number = response.data.data.revision_number;
        this.linked_art = response.data.data.linked_art;
        this.place = response.data.data.place;
        this.selectedResponsibles = response.data.data.technicals;
        this.inventoryLastUpdatedAt = response.data.data.updated_at;
      });
    },
    getTechnicalResponsibles: async function(){
      await axios
        .get(
          `${process.env.VUE_APP_API_HOST}/api/admin/companies/${this.localCompanyId}/technical-responsible`
        ).then((response)=>{
          this.technicalResponsibles= response.data;
        })
    },
    getMachinesByCompanyId: async function () {
      const response = await axios.get(
        `${process.env.VUE_APP_API_HOST}/api/admin/machines?include=protectionSystems,inventories&company_id=${this.localCompanyId}`,
        {
          params: {
            not_paginated: true,
            not_gallery: true,
          },
        }
      );
      this.machines = response.data.data;

      const sanitizedMachine = this.machines.map((machine)=>{

        machine.selected = machine.inventories;
        machine.selected = false;
        machine.inventories.forEach((el) => {
          if (el.id == this.id) {
            machine.selected = true;
          }
          else{
            machine.selected = false;
          }
        });
        if (!machine.protection_systems) {
          machine.protection_systems = [];
        } else {
          machine.protection_systems.forEach((protectionSystem) => {
            if (protectionSystem.photo) {
              protectionSystem.image = protectionSystem.photo.url;
            }
          });
        }
        return machine;
      })
      this.machines = sanitizedMachine;

      this.machines.sort((a, b) =>
        a.created_at < b.created_at ? 1 : b.created_at < a.created_at ? -1 : 0
      );
    },
    addProtectionSystem(machine) {
      if (this.tempImage[machine.id] != "" && this.tempDescription != "") {
        this.renderPs = false;
        let protection_system = {
          image: this.tempImage[machine.id],
          description: this.tempDescription,
        };
        this.tempDescription = "";
        this.tempImage[machine.id] = "";
        this.tempPath = "";
        this.message = "";
        if(machine.protection_systems.length === 8){
          this.limitExceeded = true;
          setTimeout(() => {
            this.limitExceeded = false;
          }, 3000);
          this.renderPs = true;
          this.registersStack.pop();
        }else{
          this.save(protection_system, machine);
          this.renderPs = true;
          this.registersStack.pop();
        }
      } else {
        this.erroDevice = true;
        setTimeout(() => {
          this.erroDevice = false;
        }, 1500);
      }
    },
    newMachineForm() {
      this.creatingNewMachine = !this.creatingNewMachine;
      if (this.creatingNewMachine) {
        this.registersStack.push("uma máquina");
      } else {
        this.registersStack.pop();
      }
    },
    required: function (attribute) {
      return this.$v.machine[attribute].$params.required;
    },
    openModal: function (modal, machineId) {
      this.machineSelectedId = machineId;
      this.$refs[modal].show();
    },
    generateNumberCode: function () {
      axios
        .get(
          `${
            process.env.VUE_APP_API_HOST
          }/api/admin/get-document-count-by-user/${localStorage.getItem(
            "auth.user_id"
          )}`
        )
        .then((response) => {
          let userCode = localStorage.getItem("auth.user_id").substring(0, 4);
          let date = moment().format("YY.MM.DD");
          this.number_code = `${date}.${userCode}.${response.data}`;
        });
    },
    save(protection_system, machine) {
      this.saving = true;
      this.renderPs = false;
      let image = protection_system.image.split(",")[1];
      let promise = axios.post(
        `${process.env.VUE_APP_API_HOST}/api/admin/protection-systems/`,
        {
          description: protection_system.description,
          inventory_id: this.id,
          machine_id: machine.id,
          image: image,
        }
      );
      promise
        .then((response) => {
          protection_system.id = response.data.id;
          machine.protection_systems.push(protection_system);

          this.saving = false;
          this.renderPs = true;
        })
        .catch(() => {
          this.renderPs = true;
        });
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },

    updateInventory: function () {
      //document.getElementById('btnSalvarInventario').style.display = 'none';
      if (this.registersStack.length > 0) {
        this.dismissCountDown = this.dismissSecs;
        //document.getElementById('textoAguarde').style.display='none';
        //document.getElementById('btnSalvarInventario').style.display = '';
      } else {
        let promise = axios.put(
          `${process.env.VUE_APP_API_HOST}/api/admin/inventories/` + this.id,
          {
            revision_number: this.revision_number,
            linked_art: this.linked_art,
            number_code: this.number_code,
            place: this.place,
            company_id: this.localCompanyId,
            inventory_id: this.id,
            user_id: localStorage.getItem("auth.user_id"),
            machines: this.machines.some(el => el.selected)
              ? this.machines.filter(el => el.selected)
              : [],
            technical_responsivel: this.selectedResponsibles,
          }
        );
        promise.then(() => {
          localStorage.setItem('inventory_success_notification', 'true');
          
          setTimeout(() => {
            this.success = false;
            this.$router.push({
              name: 'ListDocuments',
              params: {
                company_id: this.localCompanyId,
                doctype: 'Inventory',
                docTypeText: 'Inventários'
              }
            });
            //redirect
          }, 1500);
        });
      }
    },
    uploadImage: function (e) {
      const file = e.target.files[0];

      if (!file.type.includes("image/")) {
        return;
      }

      if (typeof FileReader === "function") {
        const reader = new FileReader();

        reader.onload = (event) => {
          this.tempImage[this.newMachine.id] = event.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    removePhoto(machine, index) {
      if (machine && Array.isArray(machine.protection_systems)) {
        let promise = axios.delete(
        `${process.env.VUE_APP_API_HOST}/api/admin/protection-systems/${machine.protection_systems[index].id}`
      );
      promise
        .then(() => {
          this.saving = false;
          this.renderPs = true;
        })
        .catch(() => {
          this.renderPs = true;
        });
        machine.protection_systems.splice(index, 1);
        this.$forceUpdate();
      } else {
        console.error('Machine is undefined or machine.protection_systems is not an array');
      }
    },
    getExportUrl: function () {
      return `${process.env.VUE_APP_API_HOST}/export-inventory/${this.id}.pdf`;
    },
    saveImage: function (machineId) {
      this.registersStack.push("um sistema de segurança");
      this.tempImage[machineId] = this.$refs.imageEditor.getImageEdit();
    },
    scrollToElement() {
      const el = this.$el.getElementsByClassName("alertError")[0];
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    },
    showMachineError: function (index, attribute) {
      return (
        this.$v.machines &&
        this.$v.machines.length > 0 &&
        this.$v.machines[index][attribute].$invalid &&
        this.submited
      );
    },
    updateMachine(index) {
      this.machineSuccess = false;
      axios
        .put(
          `${process.env.VUE_APP_API_HOST}/api/admin/machines/` +
            this.machines[index].id,
          {
            name: this.machines[index].name,
            type: this.machines[index].type,
            capacity: this.machines[index].capacity,
            manufacturer: this.machines[index].manufacturer,
            tension: this.machines[index].tension,
            manufactured_at: this.machines[index].manufactured_at,
            serie_number: this.machines[index].serie_number,
            sector: this.machines[index].sector,
            observations: this.machines[index].observations,
            machine_function: this.machines[index].machine_function,
          }
        )
        .then((response) => {
          this.machineSuccess = true;
          setTimeout(() => {
            this.machineSuccess = false;
          }, 1500);
          return response.data;
        })
        .catch(() => {
          this.warning = true;
        });
    },
  },
  beforeDestroy() {
    this.stopPdfWatcher({ recheck: false });
  },
  beforeRouteLeave(to, from, next) {
    if (this.registersStack.length > 0) {
      this.dismissCountDown = this.dismissSecs;
      this.scrollToElement();
      next(false);
    } else {
      next();
    }
    this.stopPdfWatcher({ recheck: false });
  },
};
</script>
<style lang="scss">
@import "node_modules/bootstrap/scss/bootstrap";
@import "node_modules/bootstrap-vue/src/index.scss";
@import "src/styles/General.scss";
@import "src/styles/Inventory.scss";
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
